export const BLOCKS_CONSTS = {
    BLOCKS_GET: "BLOCKS_GET",
    BLOCKS_GET_BY_ID: "BLOCKS_GET_BY_ID",
    BLOCKS_UPDATE_BY_ID: "BLOCKS_UPDATE_BY_ID",
};